package com.jingfangpai.syndrome.model

import com.jingfangpai.common.orm.mapping.SyndromeIndicationSignSymptomCharacteristic
import kotlinx.serialization.Serializable

@Serializable
class SyndromeIndicationSignSymptomCharacteristicDetail: SyndromeIndicationSignSymptomCharacteristic(){
    var name:String?=null
    var description:String?=null
    override fun equals(other: Any?): Boolean {
        if (this === other) return true
        if (other == null || this::class != other::class) return false
        if (!super.equals(other)) return false

        other as SyndromeIndicationSignSymptomCharacteristicDetail

        if (description != other.description) return false

        return true
    }

    override fun hashCode(): Int {
        var result = super.hashCode()
        result = 31 * result + (description?.hashCode() ?: 0)
        return result
    }

}